import { mapKeys } from "lodash";
import { CoursesMap, CourseType } from "../types";

export default function keyCoursesByPasscode(
  courses: CourseType[]
): CoursesMap {
  return mapKeys(courses, ({ passcode }) => passcode);
}
